module.exports = __webpack_public_path__ + "static/img/图层25.a46bdad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/facilitator/图层25.png
// module id = +Ch9
// module chunks = 0